import { defaultLocations } from "@/components/locations/find-a-location";
import { Component } from "@builder.io/sdk";

export const findALocationConfig: Component = {
  name: "Find a Location",
  inputs: [
    {
      name: "heading",
      type: "string",
      required: true,
      helperText: "Heading for the section",
      defaultValue: "Our Service Areas",
    },
    {
      name: "locations",
      type: "list",
      subFields: [
        {
          name: "name",
          type: "string",
          required: true,
          helperText: "Location name (e.g. Campbell)",
        },
        {
          name: "rating",
          type: "number",
          required: true,
          helperText: "Rating for the location (e.g. 4.5)",
        },
        {
          name: "address",
          type: "string",
          required: true,
          helperText:
            "Full street address (e.g. 419 E Hamilton Ave, Campbell, CA 95008)",
        },
        {
          name: "phone",
          type: "string",
          required: true,
          helperText: "Phone number with country code (e.g. +1 (650) 328-1001)",
        },
        {
          name: "email",
          type: "string",
          required: true,
          helperText: "Contact email address (e.g. info@careindeed.com)",
        },
        {
          name: "hours",
          type: "string",
          required: true,
          helperText: "Operating hours (e.g. 12:00 AM - 11:59 PM)",
        },
        {
          name: "lat",
          friendlyName: "Latitude",
          type: "number",
          required: true,
          helperText: "Latitude coordinate (e.g. 37.29469586514765)",
        },
        {
          name: "lng",
          friendlyName: "Longitude",
          type: "number",
          required: true,
          helperText: "Longitude coordinate (e.g. -121.94221652890285)",
        },
        {
          name: "link",
          type: "string",
          required: true,
          helperText: "URL for learn more page (e.g. /locations/campbell)",
        },
      ],
      defaultValue: defaultLocations,
    },
    {
      name: "showServiceArea",
      type: "boolean",
      defaultValue: false,
      friendlyName: "Show Service Area",
      helperText: "Do you want to show the service area?",
    },
    {
      name: "overrideServiceArea",
      type: "boolean",
      defaultValue: false,
      advanced: true,
      helperText: "Override the default service area",
    },
    {
      name: "serviceAreaKMZ",
      friendlyName: "Service Area KMZ/KML File",
      type: "file",
      helperText:
        "Upload a KMZ or KML file to override the default service area",
      required: true,
      allowedFileTypes: ["kmz", "kml"],
      advanced: true,
      showIf: "options.get('overrideServiceArea') === true",
    },
  ],
};
